import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective } from '../flex-layout';

export interface ConfirmDialogData {
  title: string;
  yes?: string;
  no?: string;
  color?: string; // Deprecated: use yesColor instead
  yesColor?: string;
  noColor?: string;
  message: string;
  hideNo?: boolean;
  showDismissIcon?: boolean;
}

@Component({
  selector: 'rspl-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FxLayoutDirective,
    FxLayoutAlignDirective,
    MatButton,
    MatIcon,
    FxLayoutGapDirective,
  ],
})
export class ConfirmDialogComponent {
  public constructor(
    public reference: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
  ) {}

  public onChoice(choice: boolean): void {
    this.reference.close(choice);
  }
}
